import styled from "styled-components";

export const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1411px;
  margin: 0 auto;
  padding: 9px 85px;
  h6 {
    font-size: 19px;
    font-weight: bold;
    align-self: center;
    margin-bottom: 0;
  }
  @media (max-width: 1250px) {
    padding: 9px 13px;
  }
`;

export const Container = styled.div`
  padding: 0px 0 28px 0;
  width: 100%;
  margin: 0 auto;
  .dummy-div {
    height: 52px;
  }
  @media (max-width: 1024px) {
    .dummy-div {
      height: 10px;
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  // max-width: 1411px;
  margin: 0 auto;
  // padding: 0 25px;
  .MuiAppBar-colorPrimary {
    padding-bottom: 15px;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 1024px) {
    top: 0px;
  }
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`;

export const TopHeading = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 15px;
  align-items: center;
  padding: 16px 0;
  h4 {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.005em;
    color: #005586;
    font-family: "latobold";
    margin: 5px 0;
  }
  p {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: rgba(17, 17, 17, 0.8);
    margin: 5px 0;
  }
`;

export const OuterWrapper = styled.div`
  padding: 0 90px 30px;
  min-height: calc(100vh - 98px);
  max-width: 1920px;
  margin: 0 auto;
`;

export const BodyContainer = styled.div``;

export const Footer = styled.div`
  margin-top: 20px;
  button {
    width: 100%;
    max-width: 272px;
    margin: 0 auto;
    height: 36px;
    border-radius: 5px;
    background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
    font-size: 16px !important;
  }
`;

export const InputFieldsWrapper = styled.div`
  .css-os3nnz-control, .css-1lmoifu-control {
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(225, 225, 225);
    border-radius: 0px;
    padding: 0px;
  }
  .css-1r0b6xv-control:hover {
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(225, 225, 225);
    border-radius: 0px;
    padding: 0px;
    border: none;
    box-shadow: none;
    border-radius: 0;
    border-color: white !important;
  }
  input {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
  }
  .file-input-wrapper .MuiFormControl-root {
    border: none;
    height: 0;
  }
  .custom-date-piker .MuiIconButton-root .MuiIconButton-label {
    margin-bottom: 5px;
  }
  .MuiInputBase-root {
    input {
      padding-bottom: 8px;
    }
  }
  .css-4ljt47-MenuList {
    max-height: 180px;
  }
  .custom-file-input1 {
    margin-bottom: 0;
  }
`;

export const FormWrapper = styled.div`
  padding: 20px 20px;
  background: #FFFFFF;
  border: 1.5px solid rgba(211, 211, 211, 0.5);
  border-radius: 15px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .request-order-upload-section {
    .error-message-multiple {
      position: absolute;
      top: 11px;
      left: 227px;
    }
  }
  .material-and-Condition {
    display: flex;
  }
  .business-name-wrapper {
    display: flex;
    gap: min(1.1vw, 102px);
    align-items: flex-end;
    margin-top: 10px;
    > .app-input-text {
      width: 100%;
      max-width: 896px;
    }
    .custom-select__control {
      border-bottom: 1px solid rgb(224, 224, 224);
    }
    .equipment-requirements-wrapper {
      max-width: 576px;
      width: 100%;
      .requirements-checkbox {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .clone-outer-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    .app-input-text {
      margin-bottom: 0px !important;
    }
  }
  .clone-order-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(216, 216, 216, 0.4);
    border: 0.5px solid #D8D8D8;
    border-radius: 4px;
    padding-right: 10px;
    .checkbox-field {
      padding: 5px 9px;
      margin: 0px !important;
      .checkbox-container {
        margin: 5px 0;
        color: #979797;
        font-size: 14px;
      }
    }
  }
  .condition-styles {
    .checkbox-field {
      margin: 0px !important;
    }
  }
  .material-fields-styles {
    .app-input-text {
      margin-bottom: 0px !important;
    }
  }
  > div {
    display: flex;
    gap: clamp(20px, 6.25vw, 120px);
    > div {
      flex: 1;
      min-width: 860px;
      :nth-child(2) {
        max-width: 655px;
        min-width: auto;
      }
    }
  }
  .sec-label {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: #000;
    font-family: "latobold";
    margin-bottom: 15px;
  }
  .label-heading {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: #005586;
    margin-bottom: 10px;
  }
  @media (max-width: 1626px) {
    > div {
      > div {
        min-width: 730px;
      }
    }
  }
  @media (max-width: 1478px) {
    > div {
      gap: 40px;
      > div {
        min-width: auto;
      }
    }
  }
  @media (max-width: 1277px) {
    > div {
      > div {
        min-width: 565px;
      }
    }
  }
  .star {
    color: red;
  }
  .css-4ljt47-MenuList, .css-11unzgr {
    max-height: 180px;
  }
`;

export const UploadSpec = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: flex-start;
  span {
    white-space: normal;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    text-overflow: ellipsis;
    padding-top: 5px;
    cursor: pointer;
  }
  img {
    margin-right: 5px;
    cursor: pointer;
  }
`;

export const HardSoftWoodWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  margin-right: 20px;
  .radio-checkmark {
    width: 18px;
    height: 18px;
    border-radius: 0px;
  }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    display: flex;
    align-items: center;
    span {
      white-space: nowrap;
    }
  }
`;

export const AddMixPalletBtn = styled.button`
  background: ${props => props.active ? '#005586' : '#ffffff'};
  color: ${props => props.active ? '#ffffff' : '#005586'};
  border: 1px solid #005586;
  padding: 8px 18px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  svg {
    font-size: 16px;
  }
  &:hover {
    background: ${props => props.active ? '#003e63' : '#f0f9ff'};
  }
`;

export const MixHeaderGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
  align-items: flex-start;
  margin-bottom: 25px;

  > div {
    min-width: 0;
    width: 100%;
    position: relative;
  }

  .error-message {
    font-size: 11px !important;
    color: #ef4444 !important;
    margin-top: 3px !important;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    white-space: nowrap !important;
    z-index: 5 !important;
  }

  .app-input-text, .text-input-styles, .custom-date-piker .app-input-text {
    margin-bottom: 0 !important;
    border: none !important;
    border-bottom: none !important;
    background: transparent !important;
    width: 100% !important;
  }
  label, .mix-field-label {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #333;
    display: block;
  }

  input:not([type="checkbox"]), .form-control, .app-input-text input, .text-input-styles input, .s-input, .-time, select {
    border: 1px solid #d1d5db !important;
    background-color: #ffffff !important;
    border-radius: 6px !important;
    height: 38px !important;
    min-height: 38px !important;
    padding: 0 10px !important;
    font-size: 13px !important;
    box-shadow: none !important;
    outline: none !important;
    box-sizing: border-box !important;
    width: 100% !important;
    color: #1e293b !important;

    &:disabled {
      background-color: #f1f5f9 !important;
      border-color: #e2e8f0 !important;
    }
  }

  .custom-date-piker {
    width: 100% !important;
    height: 38px !important;
    .file-input-wrapper {
      height: 38px !important;
      border: none !important;
      background: transparent !important;
    }
    .MuiFormControl-root {
      margin: 0 !important;
      width: 100% !important;
      height: 38px !important;
    }
    .MuiInputBase-root {
      border: 1px solid #d1d5db !important;
      background-color: #ffffff !important;
      border-radius: 6px !important;
      height: 38px !important;
      min-height: 38px !important;
      box-sizing: border-box !important;
      padding: 0 8px 0 10px !important;
      font-size: 13px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;

      &:before, &:after {
        display: none !important;
      }
    }
    .MuiInputBase-input {
      padding: 0 !important;
      height: 36px !important;
      line-height: 36px !important;
      font-size: 13px !important;
      background: transparent !important;
      border: none !important;
      color: #1e293b !important;
    }
    .MuiInputAdornment-root {
      margin-left: 0 !important;
      height: 36px !important;
      display: flex !important;
      align-items: center !important;
      button {
        padding: 4px !important;
      }
    }
  }

  div[class*="-control"], 
  .react-select__control, 
  .custom-select__control, 
  .Select-control {
    border: 1px solid #d1d5db !important;
    background-color: #ffffff !important;
    border-radius: 6px !important;
    height: 38px !important;
    min-height: 38px !important;
    max-height: 38px !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }

  div[class*="-control"][class*="-is-disabled"], 
  .react-select__control--is-disabled, 
  .custom-select__control--is-disabled, 
  .Select-control--is-disabled {
    background-color: #f1f5f9 !important;
    border-color: #e2e8f0 !important;
  }

  div[class*="-ValueContainer"], 
  .react-select__value-container, 
  .custom-select__value-container {
    padding: 0 10px !important;
    height: 36px !important;
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    overflow: hidden !important;
    flex: 1 !important;
  }

  div[class*="-Input"] input,
  div[class*="-input-container"] input,
  .react-select__input,
  .custom-select__input,
  .react-select__input-container input,
  .custom-select__input-container input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  div[class*="-singleValue"], 
  .react-select__single-value, 
  .custom-select__single-value {
    color: #1e293b !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    top: 62% !important;
    transform: translateY(-50%) !important;
    left: 10px !important;
    max-width: calc(100% - 20px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  div[class*="-placeholder"], 
  .react-select__placeholder, 
  .custom-select__placeholder {
    color: #94a3b8 !important;
    font-size: 13px !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    left: 10px !important;
    max-width: calc(100% - 20px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  div[class*="-IndicatorsContainer"], 
  .react-select__indicators, 
  .custom-select__indicators {
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
    padding-right: 6px !important;
  }

  div[class*="-indicatorContainer"], 
  .react-select__dropdown-indicator, 
  .custom-select__dropdown-indicator {
    padding: 4px !important;
    color: #64748b !important;
  }
`;

export const PalletRowContainer = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
  .checkbox-field {
    margin: 0 !important;
  }
`;

export const RowUploadFileBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 16px;
  padding: 2px 10px;
  font-size: 13px;
  color: #334155;

  span.filename {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.full-filename {
    white-space: nowrap;
    overflow: visible;
  }
  span.remove-icon {
    margin-left: 6px;
    cursor: pointer;
    font-weight: bold;
    color: #64748b;
    &:hover { color: #ef4444; }
  }
`;

export const PalletRowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr) 100px;
  gap: 12px;
  align-items: flex-start;

  &.has-custom-size {
    grid-template-columns: repeat(8, 1fr) 100px;
    gap: 8px;
  }

  &.has-custom-size-and-moisture {
    grid-template-columns: repeat(9, 1fr) 100px;
    gap: 6px;
  }

  > div {
    min-width: 0;
    width: 100%;
    position: relative;
  }

  .error-message {
    font-size: 11px !important;
    color: #ef4444 !important;
    margin-top: 3px !important;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    white-space: nowrap !important;
    z-index: 5 !important;
  }

  .mix-field-label {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #333;
    display: block;
  }

  .app-input-text, .text-input-styles, .custom-date-piker .app-input-text {
    margin-bottom: 0 !important;
    border: none !important;
    border-bottom: none !important;
    background: transparent !important;
    width: 100% !important;
  }

  input:not([type="checkbox"]), .form-control, .app-input-text input, .text-input-styles input, .s-input, .-time, select {
    border: 1px solid #d1d5db !important;
    background-color: #ffffff !important;
    border-radius: 6px !important;
    height: 38px !important;
    min-height: 38px !important;
    padding: 0 10px !important;
    font-size: 13px !important;
    box-shadow: none !important;
    outline: none !important;
    box-sizing: border-box !important;
    width: 100% !important;
    color: #1e293b !important;

    &:disabled {
      background-color: #f1f5f9 !important;
      border-color: #e2e8f0 !important;
    }
  }

  div[class*="-control"], 
  .react-select__control, 
  .custom-select__control, 
  .Select-control {
    border: 1px solid #d1d5db !important;
    background-color: #ffffff !important;
    border-radius: 6px !important;
    height: 38px !important;
    min-height: 38px !important;
    max-height: 38px !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }

  div[class*="-control"][class*="-is-disabled"], 
  .react-select__control--is-disabled, 
  .custom-select__control--is-disabled, 
  .Select-control--is-disabled {
    background-color: #f1f5f9 !important;
    border-color: #e2e8f0 !important;
  }

  div[class*="-ValueContainer"], 
  .react-select__value-container, 
  .custom-select__value-container {
    padding: 0 10px !important;
    height: 36px !important;
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    overflow: hidden !important;
    flex: 1 !important;
  }

  div[class*="-Input"] input,
  div[class*="-input-container"] input,
  .react-select__input,
  .custom-select__input,
  .react-select__input-container input,
  .custom-select__input-container input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  div[class*="-singleValue"], 
  .react-select__single-value, 
  .custom-select__single-value {
    color: #1e293b !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    top: 62% !important;
    transform: translateY(-50%) !important;
    left: 10px !important;
    max-width: calc(100% - 20px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  div[class*="-placeholder"], 
  .react-select__placeholder, 
  .custom-select__placeholder {
    color: #94a3b8 !important;
    font-size: 13px !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    left: 10px !important;
    max-width: calc(100% - 20px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  div[class*="-IndicatorsContainer"], 
  .react-select__indicators, 
  .custom-select__indicators {
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
    padding-right: 6px !important;
  }

  div[class*="-indicatorContainer"], 
  .react-select__dropdown-indicator, 
  .custom-select__dropdown-indicator {
    padding: 4px !important;
    color: #64748b !important;
  }
`;

export const RowActionGroup = styled.div`
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 5px !important;
  margin-top: 25px !important;
  grid-column: -1 !important;
  justify-self: flex-end !important;
  margin-left: auto !important;
`;

export const RowActionButton = styled.button`
  width: 28px !important;
  height: 28px !important;
  border-radius: 4px !important;
  border: 1px solid #cbd5e1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;

  &.add-btn {
    background-color: #22c55e !important;
    color: #ffffff !important;
    border-color: #16a34a !important;
    &:hover { background-color: #16a34a !important; }
  }

  &.remove-btn {
    background-color: #ef4444 !important;
    color: #ffffff !important;
    border-color: #dc2626 !important;
    &:hover { background-color: #dc2626 !important; }
  }

  &.upload-btn {
    background-color: #22c55e !important;
    color: #ffffff !important;
    border-color: #16a34a !important;
    &:hover { background-color: #16a34a !important; }
  }
`;

export const CloneOuterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
`;
